import vrb from 'bsm-validation-rules';
import { types } from '@/helpers/validations';

export const rules = {
  name: [vrb.presence(), ...types.string(100), ...types.name],
  publisherType: [vrb.presence(), vrb.typeOf('string')],
  countryCode: [vrb.presence(), ...types.countryCode],
  status: [vrb.presence(), vrb.typeOf('string')],
};
